import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HelpCenter } from './pages/HelpCenter';
import { FAQPage } from './pages/FAQPage';
import { RecurringOrdersPage } from './pages/RecurringOrdersPage';
import { PromotionsPage } from './pages/PromotionsPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { ArticlePage } from './pages/ArticlePage';
function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen font-sans text-[#2c3f49]" data-id="element-1">
        <Navbar data-id="element-2" />
        <div className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HelpCenter data-id="element-6" />} data-id="element-5" />
            <Route path="/preguntas-frecuentes" element={<FAQPage data-id="element-8" />} data-id="element-7" />
            <Route path="/compras-recurrentes" element={<RecurringOrdersPage data-id="element-10" />} data-id="element-9" />
            <Route path="/promociones-y-descuentos" element={<PromotionsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/pagos-y-facturas" element={<PaymentsPage data-id="element-14" />} data-id="element-13" />
            <Route path="/:slug" element={<ArticlePage data-id="element-16" />} data-id="element-15" />
          </Routes>
        </div>
        <Footer data-id="element-17" />
      </div>
    </Router>;
}
export { App };